import { render, staticRenderFns } from "./ziping.vue?vue&type=template&id=3573a69c&"
import script from "./ziping.vue?vue&type=script&lang=js&"
export * from "./ziping.vue?vue&type=script&lang=js&"
import style0 from "./ziping.vue?vue&type=style&index=0&id=3573a69c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports